import { routes } from 'routes';

export const getAuthToken = () => {
  const token = window.localStorage.getItem('token');

  return `Bearer ${token}`;
};

export const redirectToRoot = () => window.location.assign(routes.rootPath());
